import { render, staticRenderFns } from "./ForeignerNatural.vue?vue&type=template&id=f8fa9494"
import script from "./ForeignerNatural.vue?vue&type=script&lang=js"
export * from "./ForeignerNatural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports